import {getImageUrl} from 'util/configuration';

const MAX_CACHE_SIZE = 40;

class Geto {
    constructor(isFullImage) {
        this.cache = [];
        this.pendingRequests = new Map();
        this.isFullImage = isFullImage;
    }

    async fetchBlob(id) {
        const imageUrl = getImageUrl(id, (this.isFullImage ? 'scrollable' : 'profile'));
        try {
            // Check if the image is already in the cache
            console.log('[img] get before cache ' + imageUrl);
            for (let cachedItem of this.cache) {
                if (cachedItem.URL === imageUrl) {
                    cachedItem.LAST_ACCESS = new Date();
                    return cachedItem.BLOB;
                }
            }

            // Check if there is an ongoing request for the same image
            if (this.pendingRequests.has(imageUrl)) {
                return await this.pendingRequests.get(imageUrl);
            }

            // Create a new request and store the promise in pendingRequests
            const imageBlobPromise = fetch(imageUrl, {mode: 'cors'})
                .then(response => response.blob());

            this.pendingRequests.set(imageUrl, imageBlobPromise);

            const imageBlob = await imageBlobPromise;

            // Remove the request from pendingRequests once it is complete
            this.pendingRequests.delete(imageUrl);

            // Manage cache size and add the new image to the cache
            if (this.cache.length >= MAX_CACHE_SIZE) {
                let oldestItemIndex = 0;
                for (let i = 1; i < this.cache.length; i++) {
                    if (this.cache[i].LAST_ACCESS < this.cache[oldestItemIndex].LAST_ACCESS) {
                        oldestItemIndex = i;
                    }
                }
                this.cache.splice(oldestItemIndex, 1);
            }

            this.cache.push({BLOB: imageBlob, URL: imageUrl, LAST_ACCESS: new Date()});
            return imageBlob;
        } catch (error) {
            console.error('Error fetching image:', error);
            this.pendingRequests.delete(imageUrl);
            return null;
        }
    }
}

export default Geto;
